<input
  type="file"
  class="file-input"
  #fileInput
  (change)="select($event)"
  accept="image/*"
/>

<ng-container *ngIf="!previewImage && !image; else previewTpl">
  <button
    (click)="fileInput.click()"
    [disabled]="uploading"
    class="size-full"
    [class.pointer-events-none]="readonly"
    [class.bg-gray-100]="readonly"
  >
    <ng-container *ngIf="uploading; else selectableTpl">
      <clr-spinner clrInline></clr-spinner>
      {{ 'asset.uploading' | translate }}
    </ng-container>
    <ng-template #selectableTpl>
      <div class="flex flex-col items-center justify-center gap-2 p-3">
        <img
          class="size-10"
          src="assets/icons/icn-image-upload.svg"
          alt="icn-upload"
        />
        <p>{{ 'asset.select-file' | translate }}</p>
        <p class="text-[12px] text-gray-400">
          {{ 'asset.select-file-description' | translate }}
        </p>
      </div>
    </ng-template>
  </button>
</ng-container>

<ng-template #previewTpl>
  <div
    class="flex flex-col items-center justify-center gap-2 h-full p-2"
    [class.pointer-events-none]="readonly"
    [class.bg-gray-100]="readonly"
  >
    <img
      [src]="previewImage || image"
      alt="preview-image"
      class="max-w-[300px] max-h-[90px] object-contain"
    />
    <button
      (click)="fileInput.click()"
      [disabled]="uploading"
      class="flex items-center gap-2 btn btn-primary outlined"
    >
      {{ 'asset.change-image' | translate }}
      <vdr-icon name="refresh"></vdr-icon>
    </button>
  </div>
</ng-template>

<div
  class="drop-zone"
  [ngStyle]="dropZoneStyle"
  [class.visible]="dragging"
  [class.dragging-over]="overDropZone"
  (dragenter)="overDropZone = true"
  (dragleave)="overDropZone = false"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
  #dropZone
  [class.pointer-events-none]="readonly"
  [class.bg-gray-100]="readonly"
>
  <div class="drop-label" (dragenter)="overDropZone = true">
    <clr-icon shape="upload-cloud" size="32"></clr-icon>
    {{ 'asset.drop-zone' | translate }}
  </div>
</div>
